import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { ProfileService } from '../../../core/services/profile.service';
import { PeopleService } from '../../../services/people.service';
import { GroupEmailComponent } from '../group/group-email.component';
import { ProfileDetailComponent } from '../person/profile-detail.component';
 
@Component({
    selector: 'app-person-list',
    templateUrl: './person-list.component.html',
    styleUrls: ['./person-list.component.scss'],
    standalone: false
})
export class PersonListComponent implements OnInit {
    @Input() data: any[];    
    @Input() searchterm: string;
    @Input() personDetail: ProfileDetailComponent;
    @Input() byprogram: boolean;

    public groupNames$; 

    public selectedGroupName: string = '';  // the name of the group to add or update when grouping selected people 

    constructor(
        private modalService: NgbModal,
        public profile: ProfileService,
        private peopleService: PeopleService
    ) {
        // Get the first ten matching group names 
        this.groupNames$ = (text$: Observable<string>) =>
            text$.pipe(
                debounceTime(300),
                distinctUntilChanged(),
                switchMap(term =>
                    this.peopleService.groups$.pipe(
                        map(list => list.map(group => group.Name)
                            .filter(name => name.toLowerCase().indexOf(term.toLocaleLowerCase()) > -1)),
                    )
                )
            );
    }

    ngOnInit() {
    }

    public sendEmail(email) {
        //window.open('mailto:' + email);
        window.location.href = 'mailto:' + email;
    }

    public open(openedPerson) {
        const modalRef = this.modalService.open(ProfileDetailComponent);
        modalRef.componentInstance.person = openedPerson;
        modalRef.componentInstance.searchterm = this.searchterm;
    }

    public get hasSelection(): boolean {
        var people = this.getPeople();
        return people.findIndex(a => a.isSelected) >= 0;
        
    }

    public get selectionCount(): number {
        var people = this.getPeople();
        return people.filter(a => a.isSelected).length;
    }

    public groupSelected(addGroupModal): void {
        var people = this.getPeople();
        this.modalService.open(addGroupModal).result.then((result) => {
            if (result = "save") {
                const selectedPeople = people.filter(a => a.isSelected);
                const selectedIds = selectedPeople.map(a => a.PersonId);
                this.peopleService.updateGroup(this.selectedGroupName, selectedIds);

                // Unselect everyone because the group was updated. 
                selectedPeople.forEach(a => a.isSelected = false); 
            } },
            (result) => {
                console.log("Dismissed");
            }

        )
    }

    public emailSelected(): void {
        const modalRef = this.modalService.open(GroupEmailComponent);
        modalRef.componentInstance.description = "selected people";
        modalRef.componentInstance.mailtos = this.data.filter(a => a.isSelected).map(a => a.Email).join(";"); ;
    }

    private getPeople() {
        if (this.byprogram) {
            var people = [];
            for (var i = 0; i < this.data.length; i++) {
                people = people.concat(this.data[i].People);
            }
            return people;
        } else {
            return this.data;
        }
    }
}
